import Link from '@base/components/src/Link';

import { FooterLinksProps } from './types';

const FooterLinks = ({ links }: FooterLinksProps) => {
  return (
    <ul>
      {links.map((link) => (
        <li key={link.title}>
          <Link data-testid={`footer-link-${link.title}`} href={link.href} showCursorPointer rel={link.rel}>
            {link.title}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default FooterLinks;
